module.exports = __webpack_public_path__ + "encs/web_store/avpv/img/forbid-mobile.3f6cf734.svg";